import React from 'react';
import { useLocation } from 'react-router-dom';
import { Container, Spinner } from 'react-bootstrap';
import { useAuth } from '../context/AuthContext';
import Login from '../pages/Login';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { session, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Container className="p-5 my-5 text-center">
        <Spinner animation="border" />
      </Container>
    );
  }

  if (!session) {
    // Remember where the user was headed so we can return them there
    // after they click the magic link (which lands on /auth/callback).
    localStorage.setItem('postLoginRedirect', location.pathname + location.search);
    return <Login />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
